import { ExchangeClient, HttpTransport, InfoClient } from "@nktkas/hyperliquid"
import { isHLTestnet } from "@src/features/trade/hyperliquid/constants/config"
import type { TradingSigner } from "@src/features/tradingSigner"

let infoClient: InfoClient | null = null

export function getHyperliquidInfoClient() {
  if (infoClient == null) {
    infoClient = new InfoClient({
      transport: new HttpTransport({ isTestnet: isHLTestnet() }),
    })
  }
  return infoClient
}

function adaptTradingSigner(signer: TradingSigner) {
  return {
    signTypedData: (params: Parameters<TradingSigner["signTypedData"]>[0]) =>
      signer.signTypedData(params),
    getAddresses: async () => [signer.address],
    getChainId: async () => 1337,
  }
}

export function createHyperliquidExchangeClient(signer: TradingSigner) {
  return new ExchangeClient({
    transport: new HttpTransport({ isTestnet: isHLTestnet() }),
    wallet: adaptTradingSigner(signer) as never,
  })
}
